import UserActivityComponent from '../UserActivityComponent.vue'

export default [
    {
        path: '/user-activity',
        name: 'User Activity',
        meta: { layout: 'default' },
        component: UserActivityComponent,
    },
]